import React from 'react'
import { Translation, useTranslation } from 'react-i18next'
import { Field } from '../../form'
import classNames from 'classnames'
import { MenuItem } from '@material-ui/core'
import { Controller } from 'react-hook-form'
import IconButton from '@material-ui/core/IconButton'
import FontAwesome from 'react-fontawesome'
import RichTextEditorComponent from '../employer/lightEntrepreneurs/richTextEditor.component'
/**
 * @author Huong Nguyen
 */

const minOffset = 0
const maxOffset = 60

const WorkExperienceComponent = ({
  classes,
  control,
  remove,
  index,
  // IsNotOpenForWork,
  CompanyName,
  Location,
  JobTitle,
  start_month,
  start_year,
  end_month,
  end_year,
  Responsibilities,
  KeyAchievements,
  errorsValid,
  setIsDirty
}) => {
  const { t } = useTranslation()

  function removeRow() {
    remove(index)
    setIsDirty(true)
  }

  // year selection
  const current_year = new Date().getFullYear()
  const years_option = []
  for (let i = minOffset; i <= maxOffset; i++) {
    const year = current_year - i
    years_option.push(
      <MenuItem key={i} value={year}>
        {year}
      </MenuItem>
    )
  }

  // month selection
  const months_option = []
  for (let x = 1; x <= 12; x++) {
    months_option.push(
      <MenuItem key={x} value={x}>
        {t(`months.${x}`)}
      </MenuItem>
    )
  }

  const handleFieldOnChange = () => {
    setIsDirty(true)
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <div>
              <div className="col-xs-12 col-sm-6 col-lg-3">
                <div>
                  <Field
                    name={CompanyName}
                    label={t('openForWork.label6')}
                    inputType="textfield"
                    control={control}
                    className={classNames(classes.textfield)}
                    onChange={handleFieldOnChange}
                    // disabled={IsNotOpenForWork === true ? true : false}
                  />
                  <Field
                    name={Location}
                    label={t('openForWork.label7')}
                    inputType="textfield"
                    control={control}
                    className={classNames(classes.textfield)}
                    onChange={handleFieldOnChange}
                    // disabled={IsNotOpenForWork === true ? true : false}
                  />
                  <Field
                    name={JobTitle}
                    label={t('openForWork.label8')}
                    inputType="textfield"
                    control={control}
                    className={classNames(classes.textfield)}
                    onChange={handleFieldOnChange}
                    // disabled={IsNotOpenForWork === true ? true : false}
                  />
                </div>
                <div className={classes.workTime}>
                  <div className={classNames(classes.workMonth)}>
                    <Field
                      name={start_month}
                      label={t('openForWork.label9')}
                      inputType="select"
                      control={control}
                      className={classes.select1}
                      onChange={handleFieldOnChange}
                      // disabled={IsNotOpenForWork === true ? true : false}
                    >
                      <MenuItem value={0}></MenuItem>
                      {months_option}
                    </Field>
                  </div>
                  <div className={classNames(classes.workYear)}>
                    <Field
                      name={start_year}
                      label=""
                      inputType="select"
                      control={control}
                      className={classes.select1}
                      onChange={handleFieldOnChange}
                      // disabled={IsNotOpenForWork === true ? true : false}
                    >
                      <MenuItem value={0}></MenuItem>
                      {years_option}
                    </Field>
                  </div>
                </div>
                <div className={classes.workTime}>
                  <div className={classNames(classes.workMonth)}>
                    <Field
                      name={end_month}
                      label={t('openForWork.label10')}
                      inputType="select"
                      control={control}
                      className={classes.select1}
                      onChange={handleFieldOnChange}
                      // disabled={IsNotOpenForWork === true ? true : false}
                    >
                      <MenuItem value={0}></MenuItem>
                      {months_option}
                    </Field>
                  </div>
                  <div className={classNames(classes.workYear)}>
                    <Field
                      name={end_year}
                      label=""
                      inputType="select"
                      control={control}
                      className={classes.select1}
                      onChange={handleFieldOnChange}
                      // disabled={IsNotOpenForWork === true ? true : false}
                    >
                      <MenuItem value={0}></MenuItem>
                      {years_option}
                    </Field>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-6 col-lg-9">
                <div>
                  <div className="pull-right">
                    {/* {IsNotOpenForWork ? (
                      <IconButton
                        aria-label="Delete"
                        key={index}
                        style={{ paddingRight: 0 }}
                      >
                        <FontAwesome name="trash" style={{ color: 'grey' }} />
                      </IconButton>
                    ) : ( */}
                    <IconButton
                      aria-label="Delete"
                      onClick={removeRow}
                      key={index}
                      style={{ paddingRight: 0 }}
                    >
                      <FontAwesome name="trash" style={{ color: '#F67131' }} />
                    </IconButton>
                    {/* )} */}
                  </div>
                </div>
                <div className={classes.richtexteditor}>
                  <p className={classes.p_label}>{t('openForWork.p1')}</p>
                  <div
                    className={
                      errorsValid?.Responsibilities ? classes.error : ''
                    }
                  >
                    <Controller
                      render={({ field: { value, onChange } }) => {
                        const handleEditorChange = (editorValue) => {
                          onChange(editorValue)
                          setIsDirty(true)
                        }
                        return (
                          <RichTextEditorComponent
                            height="200px"
                            value={value}
                            onEditorChange={handleEditorChange}
                            // disabled={IsNotOpenForWork === true ? true : false}
                          />
                        )
                      }}
                      name={Responsibilities}
                      control={control}
                    />
                  </div>
                </div>
                <div className={classes.richtexteditor}>
                  <p className={classes.p_label}>{t('openForWork.p2')}</p>
                  <div>
                    <Controller
                      render={({ field: { value, onChange } }) => {
                        const handleEditorChange = (editorValue) => {
                          onChange(editorValue)
                          setIsDirty(true)
                        }
                        return (
                          <RichTextEditorComponent
                            height="150px"
                            value={value}
                            onEditorChange={handleEditorChange}
                            // disabled={IsNotOpenForWork === true ? true : false}
                          />
                        )
                      }}
                      name={KeyAchievements}
                      control={control}
                    />
                  </div>
                </div>
              </div>
              <div className="row" style={{ padding: '30px' }}></div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

export default WorkExperienceComponent
